import { render } from "./Question.vue?vue&type=template&id=5a95b7c2"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__